import { render, staticRenderFns } from "./ReferralLink.vue?vue&type=template&id=76af40ae&"
import script from "./ReferralLink.vue?vue&type=script&lang=js&"
export * from "./ReferralLink.vue?vue&type=script&lang=js&"
import style0 from "./ReferralLink.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports